import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/base.less'
import VueClipboard from 'vue-clipboard2'
import { Toast, Overlay, Button } from 'vant'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Overlay)

Vue.config.productionTip = false
// 拦截器
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'yidianlife'
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
